import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  if (
    location.pathname.startsWith('/payment/') ||
    location.pathname.startsWith('/secure-admin-portal/') ||
    location.pathname.startsWith('/merchant/login') ||
    location.pathname.startsWith('/merchant/signup') ||
    location.pathname === '/login' ||
    location.pathname === '/signup' ||
    location.pathname === '/'
  ) {
    return null;
  }

  const handleLogout = () => {
    setShowLogoutConfirm(false);
    logout();
    navigate('/');
  };

  const logoutConfirmModal = showLogoutConfirm && (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: '12px', padding: '30px', maxWidth: '380px', width: '90%', textAlign: 'center', boxShadow: '0 8px 32px rgba(0,0,0,0.3)' }}>
        <div style={{ fontSize: '40px', marginBottom: '12px' }}>⚠️</div>
        <h3 style={{ margin: '0 0 8px 0', color: '#333' }}>Confirm Logout</h3>
        <p style={{ color: '#666', fontSize: '14px', marginBottom: '24px' }}>Are you sure you want to logout?</p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <button
            onClick={() => setShowLogoutConfirm(false)}
            style={{ padding: '10px 24px', border: '1px solid #ddd', borderRadius: '6px', background: '#f5f5f5', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}
          >
            Cancel
          </button>
          <button
            onClick={handleLogout}
            style={{ padding: '10px 24px', border: 'none', borderRadius: '6px', background: '#dc3545', color: '#fff', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <>
    {logoutConfirmModal}
    <nav className="navbar">
      <div className="navbar-content">
        <Link to="/" className="navbar-brand">
          <img src="/images/clickpay_pay_white.png" alt="ClickPay - Secure Payment Gateway" className="navbar-logo" />
        </Link>

        <ul className="navbar-nav">
          {currentUser ? (
            <>
              {currentUser.role === 'MERCHANT' && (
                <li><Link to="/dashboard" onClick={() => { if(window.location.pathname === '/dashboard') { window.dispatchEvent(new CustomEvent('resetDashboardTab')); } }} className="nav-link">Dashboard</Link></li>
              )}
              {currentUser.role === 'ADMIN' && (
                <li><Link to="/admin" onClick={() => { if(window.location.pathname === '/admin') { window.dispatchEvent(new CustomEvent('resetAdminTab')); } }} className="nav-link">Admin Dashboard</Link></li>
              )}
              <li>
                <span className="nav-link">
                  Welcome, {currentUser.username}
                </span>
              </li>
              <li>
                <button 
                  onClick={() => setShowLogoutConfirm(true)}
                  className="nav-link"
                  style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                >
                  Logout
                </button>
              </li>
            </>
          ) : (
            <li><Link to="/merchant/login" className="nav-link">Merchant Login</Link></li>
          )}
        </ul>
      </div>
    </nav>
    </>
  );
};

export default Navbar;
